export default __webpack_public_path__ + "static/media/second-layer-img-3.708fd28e.jpg";